var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { observe } from "mobx";
export class MarketGroupsParser {
    constructor(retriever, messageSender) {
        this.retriever = retriever;
        this.messageSender = messageSender;
        this.subscription = () => { };
    }
    activate(state) {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscription = observe(state.Items, x => this.sendMessageForCurrentItem(state, x));
            yield this.retriever.activate(state);
        });
    }
    sendMessageForCurrentItem(state, change) {
        const spliceChange = change;
        if (spliceChange.removed.length === 0 && state.Items.length === spliceChange.added.length) {
            state.selectInitial();
        }
        else {
            const newItem = state.getSelectedItem();
            if (newItem) {
                this.messageSender.SendMessage(newItem);
            }
        }
    }
    deactivate() {
        this.subscription();
        this.retriever.deactivate();
    }
}
//# sourceMappingURL=MarketGroupsParser.js.map